export enum IncidenceExternalFileType {
    IMAGE = 1,    // Imagen          
    VIDEO = 2,    // Video
    FILE = 3      // Archivo
}